import script from "./Peroid.vue?vue&type=script&setup=true&lang=js"
export * from "./Peroid.vue?vue&type=script&setup=true&lang=js"

import "./Peroid.vue?vue&type=style&index=0&id=97c705a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97c705a6"]])

export default __exports__